import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=3c35518e&"
import script from "./QuestionPreview.vue?vue&type=script&lang=js&"
export * from "./QuestionPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports